import { http, HttpResponse } from 'msw';

import { debitAccountMock1 } from '../data/debitAccounts';
import { debitCustomer1Mock } from '../data/debitCustomers';
import { resource } from '../helpers';

export const debitCustomersHandler = [
    http.get(resource('/debit-customers/:id'), async ({ params }) => {
        if (params.number === debitCustomer1Mock.number) {
            return HttpResponse.json(debitAccountMock1);
        }
        return HttpResponse.json([]);
    }),
];
